// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__3ros1","secondary":"Button_secondary__1gv5E","small":"Button_small__1WqE1","withIcon":"Button_withIcon__kCA88","disabled":"Button_disabled__1f6YP"};